import LeaveBehindOverlay from './leave-behind-overlay';
import './leave-behind-overlay.scss';

export default LeaveBehindOverlay;
